import React from 'react';

const AxiosContext = React.createContext({});

export default AxiosContext;
